import { surveyJson as surveyJsonv2 } from "./survey.v2.js";
import { surveyJson } from "./survey.v1.js";
import Mustache from "mustache";

function setDynamicVariables(survey, variables) {
    survey.pages.forEach(page => {
        page.elements.forEach(element => {
            element.title = Mustache.render(element.title, variables);
            if(element.type === 'rating') {
                element.rateDescriptions.forEach((description, index) => {
                    element.rateDescriptions[index] = Mustache.render(description, variables);
                });
            }
        });
    });
}

function setConstellationQuestions(survey) {
    survey.pages.find(a => a.name === "Work Process").elements.find(a => a.questionId == "19").title = "Where are work processes strong and where are there gaps?";
    survey.pages.find(a => a.name === "Structure & Governance").elements.find(a => a.questionId == "30").title = "Where do you see collaboration and the sharing of information working well across departments—and where does it break down?";
    survey.pages.find(a => a.name === "Leadership & Culture").elements.find(a => a.questionId == "57").title = "How well do our leaders build the One Corporate Affairs mindset and trust among the team? What can we do better?";
}

function resolveSurvey(surveyType, variables) {
    let survey = surveyJson;
    if(surveyType) {
        switch(surveyType) {
            case "OAIv2":
                survey = surveyJsonv2;
                setDynamicVariables(survey, variables);
                break;
            case "Constellation":
                setConstellationQuestions(survey);
                break;
        }
    }

    return survey;
}

export default resolveSurvey;
